<template>
  <div class="forms">
    <SessionStatus formName="reviewSubmittedDeath" v-if="submitted" v-bind:submissionId="submissionId" display="true" fieldsToFilter="barcode_" @resetEnquiry="resetEnquiry" />
    <Submitted v-if="submitted" @resetEnquiry="resetEnquiry" />    
    <TheReviewASubmittedDeathRecordForm v-else @submitEnquiry="submitEnquiry" />
    <PrivacyNotice />
  </div>
</template>

<script>
import TheReviewASubmittedDeathRecordForm from '@/components/reviewasubmitteddeathrecord/TheReviewASubmittedDeathRecordForm.vue'
import Submitted from '@/components/reviewasubmitteddeathrecord/Submitted.vue'
import SessionStatus from '@/components/session/SessionStatus.vue'
import PrivacyNotice from '../../components/PrivacyNotice.vue'

export default {
  name: 'TheReviewASubmittedDeathRecord',
  components: {
    TheReviewASubmittedDeathRecordForm,
    PrivacyNotice,
    Submitted,
    SessionStatus
  },
  data: function() {
    return {
      submitted: false,
      submissionId: ''
    }
  },
  methods: {
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      this.submissionId = result.submissionId;
      scroll(0, 0);
    },
    resetEnquiry: function() {
      this.submitted = false;
      scroll(0, 0); 
    }
  }
}
</script>

